import { ReactNode } from 'react'
import { createEffect, createEvent, createStore, sample } from 'effector'
import { NotificationInstance } from 'antd/es/notification/interface'

export type NotificationType = 'success' | 'info' | 'warning' | 'error'

export type NotificationPayload = {
  type: NotificationType
  description: string
  message?: string
  placement?: 'topRight' | 'topLeft' | 'bottomRight' | 'bottomLeft'
  duration?: number
}

export const notificationMounted = createEvent<{
  api: NotificationInstance
  contextHolder: ReactNode
}>()

export const showNotification = createEvent<NotificationPayload>()

export const showNotificationFx = createEffect(
  ({
    api,
    payload,
  }: {
    api: NotificationInstance
    payload: NotificationPayload
  }) => {
    api[payload.type]({
      message: payload?.message ?? '',
      description: payload?.description ?? '',
      placement: payload.placement ?? 'bottom',
      duration: payload.duration ?? 7,
    })
  },
)
export const $notification = createStore<{
  api: NotificationInstance | null
  contextHolder: ReactNode | null
}>({
  api: null,
  contextHolder: null,
}).on(notificationMounted, (_, payload) => payload)

sample({
  clock: showNotification,
  source: $notification,
  filter: Boolean,
  fn: ({ api }, payload) => ({
    api: api!,
    payload,
  }),
  target: showNotificationFx,
})
